import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CalculationService {
  public static CHAPVEST_API_URL = 'https://node-backend.chapwood.apps.savantly.cloud/';
  // public static CHAPVEST_API_URL = 'http://localhost:3000/';  //local
   public static CHAPTIMIZER_API_URL = 'https://chapwood-optimizer.chapwood.apps.savantly.cloud/';
  //  public static CHAPTIMIZER_API_URL = 'http://127.0.0.1:5002/'; //local

  constructor(public http: HttpClient) {}

  /** ======================================== DISTRESSES REST API ================================================== */
  /**
   * Makes a GET request for all distresss
   */
  getDistresses() {
    return this.http.get(CalculationService.CHAPVEST_API_URL);
  }
  /**
   * Makes a GET request for a specific distress
   * This method patches the associated statistic as well
   * @param id The id of the distress
   */
  getDistress(id) {
    var url = CalculationService.CHAPVEST_API_URL + id;
    return this.http.get(url);
  }
  /**
   * Makes a POST request for an distress creating a new distress
   * @param newDistress  The body of the request for an distress/The new distress object to be added
   */
  addDistress(newDistress) {
    var headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
    // headers.append('Content-Type', 'application/json');
    return this.http.post(
      CalculationService.CHAPVEST_API_URL + 'distresses',
      newDistress,
      { headers: headers }
    );
  }
  /**
   * Makes a PATCH request for an existing distress
   * @param id The id of the distress to be edited
   * @param body  The body of the request for an distress
   */
  editDistress(id, body) {
    var headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
    headers.keys;
    return this.http.patch(
      CalculationService.CHAPVEST_API_URL + 'distresses/' + id,
      body
    );
  }
  /**
   * Makes a DELETE request for a specific distress
   * @param id The id of the distress to be deleted
   */
  deleteDistress(id) {
    return this.http.delete(
      CalculationService.CHAPVEST_API_URL + 'distresses/' + id
    );
  }

  downloadPDF(payload) {
    return this.http.post(
      CalculationService.CHAPTIMIZER_API_URL + 'financialDistressPDF',
      payload,
      { responseType: 'arraybuffer' }
    );
  }
}
